<template>
  <b-container class="center-screen">
    <b-row align-content="center" align-h="center">
      
      <b-row align-h="center" class="mr-1 ml-1">
        <b-col cols="12" md="auto">
          <img
            width="225px"
            src="@/assets/images/svg/change-password-image.svg"
          />
        </b-col>
      </b-row>

      <b-row align-h="center" v-if="step === 1">
        <b-col align-self="center" cols="12" md="auto">
          
            <b-row>
                <label>
                  <strong>Digite</strong> abaixo o
                  <strong>código</strong> enviado:
              </label>
            </b-row>

            <b-row>
              <validation-observer ref="changePasswordValidator">
                <b-form class="auth-login-form" @submit.prevent>
                  <b-form-group>
                    <validation-provider
                      #default="{ errors }"
                      :custom-messages="{
                        required: 'O código é obrigatório',
                      }"
                      rules="required"
                    >
                      <b-form-input
                        v-model="hash"
                        placeholder="digite aqui..."
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-form>
              </validation-observer>
              
            </b-row>

            <b-row>
              <b-button
              variant="primary"
              @click="validateHash"
              >Enviar</b-button>
            </b-row>
            
        </b-col>
      </b-row>  

      <b-row align-h="center" v-if="step === 2">
      <b-col align-self="center" cols="12" md="auto">
          <b-row>
              <label>
                <strong>Digite</strong> e <strong>confirme</strong> sua nova
                      <strong>senha</strong>:
            </label>
          </b-row>
          <b-row>
            
            <validation-observer ref="newPasswordValidator">
              <b-form class="auth-login-form" @submit.prevent>
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    :custom-messages="{
                      required: 'Campo obrigatório',
                    }"
                    rules="required"
                  >
                    <b-form-input
                      v-model="newPassword"
                      placeholder="nova senha..."
                      :state="errors.length > 0 ? false : null"
                      type="password"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-form>
            </validation-observer>
            
          </b-row>

          

          <b-row>

            <validation-observer ref="newPasswordValidator">
            <b-form class="auth-login-form" @submit.prevent>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  :custom-messages="{
                    required: 'Campo obrigatório',
                  }"
                  rules="required"
                >
                  <b-form-input
                    v-model="newPasswordTest"
                    placeholder="repetir nova senha..."
                    :state="errors.length > 0 ? false : null"
                    type="password"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form>
          </validation-observer>
            
          </b-row>

          

          <b-row>
              <span v-if="showErrorEqual">
                  Os campos estão <strong>diferentes</strong>
              </span>
          </b-row>

          <b-row>
            <b-button
            variant="primary"
            @click="saveNewPassword"
            >Confirmar</b-button>
          </b-row>
              
      </b-col>
      </b-row>

      <b-row align-h="center" v-if="step === 3" class="mt-1">
        <b-col align-self="center" cols="12" md="auto">
            <b-row>
              <span>Senha alterada com <strong>sucesso</strong>!</span>
            </b-row>
            <b-row class="mt-1">
              <b-button
              variant="primary"
              @click="goToHome"
              >Ir para Login</b-button>
            </b-row>
        </b-col>
      </b-row>

      


    </b-row>
  </b-container>
</template>

<script>
import { required } from '@validations';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import {
  BContainer,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
} from 'bootstrap-vue';
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    
  },
  name: 'change-password',
  data() {
    return {
      step: 1,
      show1: null,
      hash: '',
      newPassword: '',
      newPasswordTest: '',
      checkbox_remember_me: false,
      showError: false,
      showErrorEqual: false,
      load: false,
      required,
    };
  },

  methods: {
    setStep(val) {
      this.step = val;
    },
    validateHash() {
      this.$refs.changePasswordValidator.validate().then((success) => {
        if(success){
          this.$store
            .dispatch('verifyHashRecoveryPassword', { hash: this.hash.trim() })
            .then(() => {
              this.setStep(2);
              this.$toast({
              component: ToastificationContent,
                props: {
                  title: 'Validado',
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              });
            })
            .catch((err) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Login',
                  text: `Erro: ${err}`,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              });
            });
        }
      })
      
    },
    saveNewPassword() {
      this.showError = false;
      if (this.newPassword && this.newPasswordTest) {
        this.showErrorEqual = false;
        if (this.newPassword === this.newPasswordTest) {
          this.$store
            .dispatch('changePassword', {
              new_password: this.newPassword,
            })
            .then(() => {
              this.setStep(3);
              this.$toast({
              component: ToastificationContent,
                props: {
                  title: 'Senha Alterada!',
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              });
            })
            .catch((err) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Login',
                  text: `Erro: ${err}`,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              });
            });
        } else {
          this.showErrorEqual = true;
        }
      } else {
        this.showError = true;
      }
    },
  goToHome(){
    this.$router.push({ name: 'login' });
  }
  },
};
</script>

<style lang="scss">
.div-venx-logo-opacity {
  width: 100%;
  position: absolute;
  bottom: 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 25%;
}

.center-screen {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
</style>